import React from 'react'
import { Icon, Tooltip } from 'antd'

import { T } from '..'
import { WrapSpan } from './styles'

interface Props {
  baggage_amount: number
  baggage_weight: number
  baggage: boolean
}

function AirBadgeBaggage({
  baggage_amount = 0,
  baggage_weight = 0,
  baggage = false
}: Props) {
  if (baggage) {
    const renderBaggageAmount = T({
      text: {
        key: 'web.services.airs.form.fare.baggage-amount',
        options: { count: baggage_amount }
      }
    })
    const renderBaggageWeight = T({
      text: {
        key: 'web.services.airs.form.fare.baggage-weight',
        options: { count: baggage_weight }
      }
    })

    return (
      <Tooltip title={`${renderBaggageAmount}, ${renderBaggageWeight}`}>
        <Icon type="shopping" />
      </Tooltip>
    )
  }

  return (
    <WrapSpan>
      <Tooltip
        title={T({ text: 'web.services.airs.form.fare.baggage-amount-no' })}
      >
        <Icon type="shopping" />
        <Icon
          type="close"
          style={{
            position: 'absolute',
            top: 3,
            left: 0,
            margin: 0
          }}
        />
      </Tooltip>
    </WrapSpan>
  )
}

export default AirBadgeBaggage
